import DashboardRepository from "./DashboardRepository";
import { InflowInfiltrationMetrics, PastOverflowMetrics } from "./Dashboard";



export default class DashboardService {
    private readonly dashboardRepository: DashboardRepository = new DashboardRepository();
    private static readonly pastOverflowCache: Map<string, PastOverflowMetrics> = new Map();

    async getInflowInfiltrationMetrics(type: string, locationId: number, assetId: number, startDate: string, endDate: string): Promise<InflowInfiltrationMetrics> {
        return await this.dashboardRepository.getInflowInfiltrationMetrics(type, locationId, assetId, startDate, endDate);
    }

    async getPastOverflowMetrics(locationId: number, startDate: string, endDate: string): Promise<PastOverflowMetrics> {
        const cacheKey = `${locationId}|${startDate}|${endDate}`;
        const cached = DashboardService.pastOverflowCache.get(cacheKey);
        if (cached) return cached;

        const metrics = await this.dashboardRepository.getPastOverflowMetrics(locationId, startDate, endDate);
        if (metrics) {
            DashboardService.pastOverflowCache.set(cacheKey, metrics);
        }
        return metrics;
    }
}